import React, { useState } from 'react';
import { getFieldValue, getRichText, renderRichText } from '../../../contentful/mappers';
import './Accordion.css';

function Accordion({ data }) {
  if (!data) return null;

  const headline = getFieldValue(data, 'headline');
  const items = getFieldValue(data, 'items') || [];

  return (
    <section className="accordion-section">
      <div className="container">
        {headline && <h2 className="section-headline">{headline}</h2>}
        <div className="accordion">
          {items.map((item, index) => (
            <AccordionItem key={item.sys?.id || index} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}

function AccordionItem({ item }) {
  const [isOpen, setIsOpen] = useState(false);
  const title = getFieldValue(item, 'title');
  const body = getRichText(item, 'body');
  const relatedLinks = getFieldValue(item, 'relatedLinks') || [];

  return (
    <div className={`accordion-item ${isOpen ? 'open' : ''}`}>
      <button
        className="accordion-header"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className="accordion-title">{title}</span>
        <span className="accordion-icon">{isOpen ? '−' : '+'}</span>
      </button>
      {isOpen && (
        <div className="accordion-content">
          {body && <div className="accordion-body">{renderRichText(body)}</div>}
          {relatedLinks.length > 0 && (
            <div className="accordion-links">
              <p>For more information, see:</p>
              <ul>
                {relatedLinks.map((link, index) => {
                  const label = getFieldValue(link, 'label');
                  const url = getFieldValue(link, 'url');
                  return (
                    <li key={index}>
                      <a href={url} target="_blank" rel="noopener noreferrer">
                        {label}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Accordion;

